import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["cep", "logradouro", "bairro", "cidade", "estado", "spinner"]

  lookup() {
    const cep = this.cepTarget.value.replace(/\D/g, "");

    if (cep.length !== 8) return;

    this.spinnerTarget.classList.remove("d-none");

    // Timeout Controller (3s)
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 8000);

    fetch(`https://viacep.com.br/ws/${cep}/json/`, {
      signal: controller.signal
    })
      .then(res => res.json())
      .then(data => {
        this.spinnerTarget.classList.add("d-none");
        clearTimeout(timeoutId);

        if (data.erro) return;

        this.logradouroTarget.value = data.logradouro || "";
        this.bairroTarget.value     = data.bairro     || "";
        this.cidadeTarget.value     = data.localidade || "";
        this.estadoTarget.value     = data.estado     || "";
      })
      .catch(err => {
        clearTimeout(timeoutId);
        this.spinnerTarget.classList.add("d-none");

        if (err.name === "AbortError") {
          console.warn("CEP lookup timeout (8s)");
        }
      });
  }

}
